<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Fábrica de Ração</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmFabricaRacao" label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field :rules="[campoObrigatorio, campoCNPJ]" v-mask="maskCNPJ" v-model.trim="registro.nrCnpj" label="CNPJ" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field :rules="[tamanhoMaximoQuarenta]" v-model.trim="registro.nrRegistroSif" label="Registro no SIF" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs11 md11 ma-5>
                    <h3><b>Dados da Localização</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field v-model.trim="registro.nmLocalidade" label="Localidade" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field type="number" v-model.number="registro.nrLatitude" label="Latitude" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field type="number" v-model.number="registro.nrLongitude" label="Longitude" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>            
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoCNPJ, tamanhoMaximoQuarenta } from '@/filters/rules'
import { formatCNPJ } from '@/filters/utils'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'
import { mask } from 'vue-the-mask'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

export default {
    name: 'FabricaRacao',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    directives: {
        mask,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            maskCNPJ: '##.###.###/####-##'
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Fábrica de Ração: ' + this.registro.idFabricaRacao

                return 'Inserindo nova Fábrica de Ração'
            }
        },
    },
    methods: {
        campoObrigatorio,
        campoCNPJ,
        formatCNPJ,
        tamanhoMaximoQuarenta,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('fabrica-racao/' + id)
            .then((response) => {
                var rec = response.data[0].data
                rec.nrCnpj = rec.nrCnpj ? `${rec.nrCnpj.substring(0, 2)}.${rec.nrCnpj.substring(2, 5)}.${rec.nrCnpj.substring(5, 8)}/${rec.nrCnpj.substring(8, 12) }-${rec.nrCnpj.substring(12, 15)}` : rec.nrCnpj
                this.registro = Object.assign({}, rec)
                this.registroBanco = Object.assign({}, rec)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
                this.$router.push({ path: '/fabricaRacao'})
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.nrLatitude = this.registro.nrLatitude == '' ? null : this.registro.nrLatitude
            if (this.registro.nrLatitude != null)
            {
                var floatNrLatitude = this.registro.nrLatitude.toString().replace(',', '.')
                this.registro.nrLatitude = parseFloat(floatNrLatitude).toFixed(7)
            }
            this.registro.nrLongitude = this.registro.nrLongitude == '' ? null : this.registro.nrLongitude
            if (this.registro.nrLongitude != null)
            {
                var floatNrLongitude = this.registro.nrLongitude.toString().replace(',', '.')
                this.registro.nrLongitude = parseFloat(floatNrLongitude).toFixed(7)
            }
            this.registro.nrCnpj = this.replaceAll('.', '', this.registro.nrCnpj).replace('/', '').replace('-', '')
            this.$axios.post('fabrica-racao/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'fabricaRacao', params: { id: response.data[0].data.idFabricaRacao }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadFabricasRacao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.nrLatitude = this.registro.nrLatitude == '' ? null : this.registro.nrLatitude
            if (this.registro.nrLatitude != null)
            {
                var floatNrLatitude = this.registro.nrLatitude.toString().replace(',', '.')
                this.registro.nrLatitude = parseFloat(floatNrLatitude).toFixed(7)
            }
            this.registro.nrLongitude = this.registro.nrLongitude == '' ? null : this.registro.nrLongitude
            if (this.registro.nrLongitude != null)
            {
                var floatNrLongitude = this.registro.nrLongitude.toString().replace(',', '.')
                this.registro.nrLongitude = parseFloat(floatNrLongitude).toFixed(7)
            }
            this.registro.nrCnpj = this.replaceAll('.', '', this.registro.nrCnpj).replace('/', '').replace('-', '')
            this.$axios.put('fabrica-racao/' + this.registro.idFabricaRacao, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadFabricasRacao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        replaceAll(searchString, replaceString, str) {
            return str.split(searchString).join(replaceString);
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('fabrica-racao/' + this.registro.idFabricaRacao)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadFabricasRacao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/fabricaRacao' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idFabricaRacao: 0,
                nmFabricaRcao: '',
                nrCnpj: '',
                nrRegistroSif: '',
                nmLocalidade: '',
                nrLatitude: '',
                nrLongitude: '',
            }
            this.registroBanco = {
                idFabricaRacao: 0,
                nmFabricaRcao: '',
                nrCnpj: '',
                nrRegistroSif: '',
                nmLocalidade: '',
                nrLatitude: '',
                nrLongitude: '',
            }
        },
        goSearch() {
            this.$router.push({ path: '/fabricaRacaoSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
